import type { CreateAnboxMachineRequest } from 'services/admin/superAdminService';
import type { InstanceStatus, MachineStatus, PaginationState } from './anbox-management.types';

export const MESSAGE_TIMEOUT_MS = 5000;

export const DEFAULT_ADD_INSTANCES_COUNT = 10;
export const DEFAULT_ADD_INSTANCES_PREFIX = 'instance';
export const DEFAULT_NEW_INSTANCE_STATUS: InstanceStatus = 'available';

export const INITIAL_MACHINE_FORM: CreateAnboxMachineRequest = {
  name: '',
  host: '',
  port: 8443,
  api_endpoint: '',
  auth_token: '',
  root_username: '',
  root_password: '',
  total_capacity: 50,
  warning_threshold: 80,
  critical_threshold: 95,
  priority: 1,
  region: '',
  provider: '',
  notes: ''
};

export const INITIAL_MACHINES_PAGINATION: PaginationState = {
  page: 1,
  limit: 20,
  total: 0,
  totalPages: 0
};

export const INITIAL_INSTANCES_PAGINATION: PaginationState = {
  page: 1,
  limit: 50,
  total: 0,
  totalPages: 0
};

export const MACHINE_STATUS_OPTIONS: readonly MachineStatus[] = [
  'active',
  'maintenance',
  'offline'
];

export const INSTANCE_STATUS_OPTIONS: readonly InstanceStatus[] = [
  'available',
  'assigned',
  'starting',
  'running',
  'stopping',
  'stopped',
  'error',
  'maintenance'
];
